import { OrganizationPage } from '~/pages/OrganizationPage';
import { loader as orgLoader } from '~/pages/OrganizationPage/loader';
import { meta as orgMeta } from '~/pages/OrganizationPage/meta';
import { handle as orgHandle } from '~/pages/OrganizationPage/handle';
import { useOrganization } from '../hooks/useOrganization';

export const meta = orgMeta;
export const handle = orgHandle;
export const loader = orgLoader;

export default function OrgPage() {
  const { organization, hasCustomDomain } = useOrganization();

  if (!organization) {
    throw new Error('Organization not found');
  }

  return (
    <OrganizationPage
      organization={organization}
      hasCustomDomain={hasCustomDomain}
    />
  );
}
